





















































































































































































import Currency from '@/components/Currency.vue';
import Metodos from '@/views/recibos/MetodosDeCobro.vue';
import Observaciones from '@/views/recibos/Observaciones.vue';
import Pendientes from '@/views/recibos/Pendientes.vue';
import Resumen from '@/views/recibos/ResumenRecibo.vue';
import Recibo from '@/models/Recibo';
import Entidad from '@/models/Entidad';
import ElCard from '@/overrides/ElCard.vue';
import { log } from 'console';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	components: {
		Currency,
		ElCard,
		Pendientes,
		Metodos,
		Resumen,
		Observaciones,
	},
	data() {
		return {
			activeCard: 0,
			typeAlert: '',
			descriAlert: '',
			titleAlert: '',
			showAlert: 99,
			start: 0,
			startp: 0,
			limit: 5,
			showBtnMore: false,
			showBtnMorePendientes: false,
			loading: false,
			loadingRecibos: false,
			refresh: false,
			btnDiabled: false,
		};
	},
	watch: {
		totalPendientesSelected(importeCobrar) {
			this.btnDiabled = false;
			this.showAlert = 99;
			if (parseFloat(importeCobrar) < 0 && this.activeCard === 1) {
				this.showAlert = 1;
				this.btnDiabled = true;
				this.typeAlert = 'error';
				this.titleAlert = 'Error';
				this.descriAlert = 'El importe a cobrar no puede ser negativo.';
			}
		},
		totalAcobrar(total) {
			this.btnDiabled = false;
			this.showAlert = 99;

			if ((parseFloat(total) < parseFloat(this.totalPendientesSelected) || Number.isNaN(total) || total === 0) && this.activeCard === 2) {
				this.showAlert = 2;
				this.btnDiabled = true;
				this.typeAlert = 'error';
				this.titleAlert = 'Error';
				this.descriAlert =
					Number.isNaN(total) || total === 0
						? 'Verifique los importes a cobrar'
						: 'El cobro debe ser igual o superior al importe a cobrar(2)';
			}
		},
		pendientesSelected(pendientes) {
			if (this.activeCard === 1 && pendientes.length === 0 && this.pendientesTable.length > 0) {
				if (this.parametros.recibos.permite_anticipos === false) this.btnDiabled = true; // primer linea control por parametros
				// this.typeAlert = 'error';
				// this.titleAlert = 'Error';
				// this.descriAlert = 'Seleccione al menos un documento a cobrar';
				this.typeAlert = 'warning';
				this.titleAlert = 'Atención';
				this.descriAlert = 'No tiene seleccionado ningun documento a cobrar';
				this.showAlert = 1;
			}
		},

		activeCard(value: number) {
			this.btnDiabled = false;

			if (value === 1 && this.pendientesSelected.length === 0 && this.pendientesTable.length > 0) {
				if (this.parametros.recibos.permite_anticipos === false) this.btnDiabled = true; // primer linea control por parametros
				this.typeAlert = 'warning';
				this.titleAlert = 'Atención';
				this.descriAlert = 'No tiene seleccionado ningun documento a cobrar ';
				this.showAlert = 1;
			}
			if (value === 2) {
				//this.showAlert = 99;
				this.btnDiabled = false;
				let total = this.totalAcobrar;
				let dif = parseFloat(total) - parseFloat(this.totalPendientesSelected);
				let difr = this.$options.filters.toCurrency(parseFloat(dif.toFixed(2)));
				this.showAlert = 2;
				if (total === 0 || Number.isNaN(total)) {
					if (this.pendientesSelected.lenght === 0) {
						// si no tiene nada seleccionado y si el total a cobrar es cero debe cargar almenos un cobro
						this.btnDiabled = true;
						this.typeAlert = 'error';
						this.titleAlert = 'Error';
						this.descriAlert = 'Debe ingresar al menos un cobro';
					}
				}
				if (this.totalPendientesSelected >= 0) {
					if (total === 0) this.typeAlert = 99;
					// si hay al menos un documento seleccionado
					this.typeAlert = total < this.totalPendientesSelected ? 'error' : 'warning';
					this.descriAlert =
						total < this.totalPendientesSelected
							? 'El cobro debe ser igual o superior al importe a cobrar (3)'
							: `La diferencia $ ${difr} se considera deuda con pago a cuenta`;
					this.titleAlert = total < this.totalPendientesSelected ? 'Error' : 'Atención';
					if (dif === 0) this.showAlert = 99;
					if (parseFloat(total) < parseFloat(this.totalPendientesSelected)) this.btnDiabled = true;
				}
			}
			if (value === 4) {
				this.showAlert = 99;
				let total = this.totalAcobrar;
				if (total === 0 && this.pendientesSelected.lenght === 0) {
					// si el total a cobrar es cero
					this.showAlert = 4;
					this.btnDiabled = true;
					this.typeAlert = 'error';
					this.titleAlert = 'Error';
					this.descriAlert = 'Debe ingresar al menos un cobro';
				}
				if (this.totalPendientesSelected === 0 && this.pendientesSelected.lenght === 0) {
					this.showAlert = 4;
					this.typeAlert = 'warning';
					this.titleAlert = 'Atención';
					this.descriAlert = 'No tiene seleccionados documentos a cobrar';
				} else {
					if (this.totalPendientesSelected > 0) {
						let dif = parseFloat(total) - parseFloat(this.totalPendientesSelected);
						let difr = this.$options.filters.toCurrency(parseFloat(dif.toFixed(2)));
						this.showAlert = 4;
						this.typeAlert = total < this.totalPendientesSelected ? 'error' : 'warning';
						this.descriAlert =
							total < this.totalPendientesSelected
								? 'El cobro debe ser igual o superior al importe a cobrar (1)'
								: `La diferencia $ ${difr} se considera deuda con pago a cuenta`;
						this.titleAlert = total < this.totalPendientesSelected ? 'Error' : 'Atención';
						if (dif === 0) this.showAlert = 99;
						if (total < this.totalPendientesSelected) this.btnDiabled = true;
					}
				}
			}
		},
	},

	computed: {
		parametros() {
			return this.$store.state.config.parametros;
		},
		cuit() {
			return this.$store.state.config.cuit;
		},
		recibosTable() {
			return this.$store.state.recibos.recibosTable;
		},
		recibosTablePendientes() {
			return this.$store.state.recibos.recibosTablePendientes;
		},
		totalPendientesSelected() {
			return this.$store.state.recibos.totalPendientesSelected;
		},
		totalAcobrar() {
			return this.$store.state.recibos.totalAcobrar;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
		pendientesSelected() {
			return this.$store.state.recibos.pendientesSelected;
		},
		pendientesTable() {
			return this.$store.state.recibos.pendientesTable;
		},
		loadingPendientes() {
			return this.$store.state.recibos.loadingPendientes;
		},
		formularioCobro() {
			return this.$store.state.recibos.formularioCobro;
		},
	},
	filters: {},
	methods: {
		suma() {
			if (this.activeCard === 4) {
				this.$confirm('Está por generar un nuevo recibo. ¿Desea continuar?', 'Atención', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancelar',
					type: 'warning',
					center: this.responsive.isMobile,
					customClass: this.responsive.isMobile ? 'confirm-mobile' : '',
				})
					.then(() => {
						this.loadingRecibos = true;
						this.$store
							.dispatch('postRecibo', this.cuit)
							.then(response => {
								if (response.data.success) {
									this.$notify({
										title: response.data.title,
										message: response.data.msg,
										position: 'top-right',
									});
									this.activeCard = 0;
									this.start = 0;
									this.startp = 0;
									this.$store.dispatch('reset');
									this.loadDataRecibo(false);
									this.loadDataRecibo(true);
									this.$store.dispatch('callPendientesTable');
									this.$store.dispatch('callFormularioCobro');
									this.$store.dispatch('callFormasCobro');
									//console.log('esta es cuit', this.axios.defaults.headers.common.Cooperativa);
									this.$store.dispatch('saveCuit', response.data.cuit);
								} else {
									this.$message({
										message: response.data.msg,
										showClose: true,
										type: 'error',
										duration: 0,
									});
								}
								this.loadingRecibos = false;
							})
							.catch(() => {
								this.loadingRecibos = false;
								this.$message({
									type: 'error',
									message: 'No se puedo generar el Recibo.',
								});
							});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: 'Operación cancelada',
						});
					});
			} else if (this.activeCard === 2) {
				//this.activeCard = this.activeCard + 1;
				if (this.valideteForm()) this.activeCard = this.activeCard + 1;
			} else this.activeCard = this.activeCard + 1;
		},
		resta() {
			this.activeCard = this.activeCard - 1;
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataRecibo(false);
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataRecibo(false);
		},
		loadMorePendientes(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.startp = this.startp + this.limit;
			this.refresh = false;
			this.loadDataRecibo(true);
		},
		loadMorePendientesClick(): void {
			this.updateScroll();
			this.startp = this.startp + this.limit;
			this.refresh = false;
			this.loadDataRecibo(true);
		},
		loadDataRecibo(pendientes: boolean): void {
			let params = {
				start: pendientes ? this.startp : this.start,
				limit: this.limit,
				pendientes: pendientes,
			};
			this.$store.dispatch('callRecibosTable', params).then((response: Recibo[]) => {
				if (response) {
					pendientes
						? response.length < 5
							? (this.showBtnMorePendientes = false)
							: (this.showBtnMorePendientes = true)
						: response.length < 5
						? (this.showBtnMore = false)
						: (this.showBtnMore = true);
					this.loading = false;
					// this.refresh = false;
					const conta = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				}
			});
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		downloadFile(doc): void {
			this.imprimiendo = true;
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom_id, codtal: doc.codtal_id, numero: doc.numero }).then(response => {
				if (response.success) {
					//window.open(`${response.host}/${response.archivo}`);
					/*
					if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) window.open(`${response.host}/${response.archivo}`, '_blank');
					else window.location.href = `${response.host}/${response.archivo}`;*/

					/*if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
						// Crea un enlace temporal y haz clic en él
						const link = document.createElement('a');
						link.href = `${response.host}/${response.archivo}`;
						link.target = '_self'; // Para que se abra en la misma ventana
						link.click();
					} else window.location.href = `${response.host}/${response.archivo}`;*/
					let url = `${response.host}/${response.archivo}`;
					if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) window.open(url, '_blank');
					else window.location.href = url;
					this.imprimiendo = false;
				} else {
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},

		downloadFileWsp(doc, aa): void {
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom_id, codtal: doc.codtal_id, numero: doc.numero }).then(response => {
				if (response.success) {
					const comentario = `Hola, podes ver el comprobante de tu recibo en: ${response.host}${response.archivo}`; // Reemplaza con el comentario que deseas compartir
					const encodedComentario = encodeURIComponent(comentario);
					const tel = this.entidadSelected.numero_celular;
					const url = tel
						? `https://api.whatsapp.com/send?phone=${tel}&text=${encodedComentario}`
						: `https://api.whatsapp.com/send?&text=${encodedComentario}`;
					if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) window.open(url, '_blank');
					else window.location.href = url;
				} else {
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},
		valideteForm() {
			let retorno = true;
			let k = 0;
			this.formularioCobro.forma.forEach(forma => {
				forma.campos.forEach(element => {
					//valido archivo
					if (element.requiredFile && element.inputtype == 'file') {
						let input;
						input = document.getElementById(`file${k}`);
						//if (element.inputtype === 'file' && !input.value && this.notIcheck(forma, k)) {
						if (element.inputtype === 'file' && !input.value) {
							this.$message({
								message: `Método cobro ${k + 1}:  El archivo es requerido`,
								showClose: true,
								type: 'error',
								duration: 0,
							});
							retorno = false;
						}
					}
					//valido resto de requeridos
					if (
						(element.required && !element.value && element.inputtype !== 'file' && element.type !== 'select') ||
						(element.required && (element.selected === '' || element.selected === undefined) && element.type === 'select')
					) {
						this.$message({
							message: `Método cobro ${k + 1}: El campo ${element.label} es requerido`,
							showClose: true,
							type: 'error',
							duration: 0,
						});

						retorno = false;
					}
				});
				k++;
			});
			return retorno;
		},
		notIcheck(forma, k) {
			let check = true;
			let c = 0;
			forma.campos.forEach(element => {
				if (element.id_ep === 'es_echeq') check = this.formularioCobro.forma[k].campos[c].value;
				c++;
			});
			return !check;
			// TODO: es una buena forma de hacerlo con some: return forma.campos.some(element => element.id_ep === 'es_echeq' && this.formularioCobro.forma[k].campos.some(campo => campo.value));
		},
		/*downloadFile(doc): void {
			let url = `./api/public/proxy/files?codcom=${doc.codcom_id}&codtal=${doc.codtal_id}&numero=${doc.numero}&cooperativa=${this.cuit}&type=pdf`;
			window.open(url);
			this.imprimiendo = false;
		},
		downloadFileWsp(doc, aa): void {
			const host = 'https://eternum.app';
			const comentario = `Hola, podes ver el comprobante de tu recibo provisorio en: ${host}/api/public/proxy/files?codcom=${doc.codcom_id}&codtal=${doc.codtal_id}&numero=${doc.numero}&cooperativa=${this.cuit}&type=pdf`; // Reemplaza con el comentario que deseas compartir
			const encodedComentario = encodeURIComponent(comentario);
			const tel = this.entidadSelected.nro_tel;
			const url = tel
				? `https://api.whatsapp.com/send?phone=${tel}&text=${encodedComentario}`
				: `https://api.whatsapp.com/send?&text=${encodedComentario}`;
			window.open(url, '_blank');
		},*/
		shareFile(doc): void {
			let url = `./api/public/proxy/recibo?codcom=${doc.codcom_id}&codtal=${doc.codtal_id}&numero=${doc.numero}&cooperativa=${this.cuit}&type=rdiprovisorio&imprime=true`;
			window.open(url);
		},
	},
	mounted() {
		this.loadDataRecibo(false);
		this.loadDataRecibo(true);
	},
};
